// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import { addToChainAfter, addToChainBefore } from "@insite/client-framework/HandlerCreator";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import {
    chain,
    DispatchCompleteLoadProducts,
    PopulateApiParameter,
    RequestDataFromApi,
} from "@insite/client-framework/Store/Data/Products/Handlers/LoadProducts";
import { getIsRecentlyPurchasedPage } from "@pacific/App/Store/Selectors/GeneralSelectors";

export const XngPopulateApiParameter: typeof PopulateApiParameter = props => {
    if (getIsRecentlyPurchasedPage(props.getState())) {
        (props.apiParameter as any).previouslyPurchasedProducts = true;
        (props.apiParameter as any).generateCategoryTree = true;
        (props.apiParameter as any).page = props.parameter.page;
        (props.apiParameter as any).pageSize = props.parameter.pageSize;
    }
};

export const XngDispatchCompleteLoadProducts: typeof DispatchCompleteLoadProducts = props => {
    props.dispatch({
        type: "xData/Products/CategoryTree",
        categoryTree: (props.apiResult as any).categoryTree,
        pagination: (props.apiResult as any).pagination,
        parameter: props.parameter,
    } as any);
};

// XNG-Changes: hawk search
export const XngRequestDataFromApi: typeof RequestDataFromApi = props => {
    const shouldApplyHawkSearchParameter = !(
        "relationship" in props.apiParameter ||
        ("productId" in props.apiParameter && props.apiParameter?.type === "alsoPurchased")
    );
    if (shouldApplyHawkSearchParameter) {
        const state = props.getState();
        const location = getLocation(state);
        const parsedQuery = parseQueryString<{ searchRequestType: string }>(location.search).searchRequestType;
        if (parsedQuery === "ImageSearch") {
            const searchImageKey = parseQueryString<{ searchImageKey: string }>(location.search).searchImageKey;
            props.apiParameter.additionalQueryStringParameters = {
                searchRequestType: parseQueryString<{ searchRequestType: string }>(location.search).searchRequestType,
                searchImageKey,
            };
        } else {
            props.apiParameter.additionalQueryStringParameters = { searchRequestType: parsedQuery };
        }
    }
};

addToChainBefore(chain, RequestDataFromApi, XngRequestDataFromApi);
addToChainAfter(chain, PopulateApiParameter, XngPopulateApiParameter);
addToChainAfter(chain, DispatchCompleteLoadProducts, XngDispatchCompleteLoadProducts);
